import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import { ArrowLeft } from "@phosphor-icons/react";

export const InfoLayout = ({ title, description, jsonLd, canonical, children, hero }) => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {canonical && <link rel="canonical" href={canonical} />}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:locale" content="de_DE" />
        <meta property="og:type" content="website" />
        {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
      </Helmet>
      <Header />
      {hero}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 mb-6">
          <ArrowLeft size={16} /> Zurück zur Startseite
        </Link>
        <article className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 sm:p-10 prose prose-slate max-w-none prose-headings:font-bold prose-headings:tracking-tight prose-h1:text-4xl prose-h1:mb-4 prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-3 prose-h3:text-lg prose-p:text-slate-700 prose-p:leading-relaxed prose-li:text-slate-700 prose-a:text-blue-600 prose-strong:text-slate-900 prose-table:text-sm">
          {children}
        </article>
      </div>
    </div>
  );
};

export default InfoLayout;
